<div class="app-modal export-progress">
  <header class="app-modal__header">
    <mat-icon class="app-modal__header-icon">download</mat-icon>
    <h2 class="app-modal__title">
      {{ progress.phase === 'building' ? 'Preparing file' : 'Exporting' }}
    </h2>
  </header>

  <div class="app-modal__body">
    <mat-progress-bar
      class="export-progress__bar"
      [mode]="indeterminate ? 'indeterminate' : 'determinate'"
      [value]="percent"
    ></mat-progress-bar>

    <p class="app-modal__subtitle">
      <ng-container *ngIf="progress.phase === 'building'; else fetchingStatus">
        Generating the file, almost done…
      </ng-container>
      <ng-template #fetchingStatus>
        <ng-container *ngIf="progress.total; else noTotal">
          {{ progress.loaded | number }} of {{ progress.total | number }} rows
          ({{ percent }}%)
        </ng-container>
        <ng-template #noTotal>
          {{ progress.loaded | number }} rows exported…
        </ng-template>
      </ng-template>
    </p>
  </div>

  <footer class="app-modal__footer">
    <button
      mat-stroked-button
      type="button"
      (click)="cancel()"
      [disabled]="progress.phase === 'building'"
    >
      Cancel
    </button>
  </footer>
</div>
